/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file SidePanelComponent.jsx - A component that exports data for sidepanel.
 */

import AddchartIcon from '@mui/icons-material/Addchart';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import SaveIcon from '@mui/icons-material/Save';
import PublishIcon from '@mui/icons-material/Publish';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
// import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import RocketSharpIcon from '@mui/icons-material/RocketSharp';
import StopCircleSharpIcon from '@mui/icons-material/StopCircleSharp';
import ConstructionIcon from '@mui/icons-material/Construction';
import ManageAccountsSharpIcon from '@mui/icons-material/ManageAccountsSharp';
import AgentIcon from '../../icons/AgentIcon';
import {
  ADD_AGENT_NODE,
  ADD_END_NODE,
  ADD_START_NODE,
  ADD_SUPERVISOR_NODE,
  ADD_TOOL_NODE,
  AGENT,
  COPY,
  COPY_GRAPH,
  CREATE,
  END,
  // GROUP,
  // GROUP_UNGROUP,
  LOAD,
  LOAD_GRAPH,
  NEW_GRAPH,
  PUBLISH,
  PUBLISH_GRAPH,
  RESET,
  RESET_GRAPH,
  SAVE,
  SAVE_GRAPH,
  START,
  SUPERVISOR,
  TOOL
} from '../../constants/AgenticTextConstants';

export const graphActionButtons = [
  { label: NEW_GRAPH, icon: AddchartIcon, actionKey: CREATE, canEdit: false },
  { label: LOAD_GRAPH, icon: HourglassBottomIcon, actionKey: LOAD, canEdit: false },
  { label: SAVE_GRAPH, icon: SaveIcon, actionKey: SAVE, canEdit: false },
  { label: PUBLISH_GRAPH, icon: PublishIcon, actionKey: PUBLISH, canEdit: false },
  { label: COPY_GRAPH, icon: RestartAltIcon, actionKey: COPY, canEdit: false },
  { label: RESET_GRAPH, icon: RestartAltIcon, actionKey: RESET, canEdit: false }
];

export const nodeCreationButtons = [
  { label: ADD_START_NODE, type: START, icon: RocketSharpIcon, canEdit: false },
  { label: ADD_SUPERVISOR_NODE, type: SUPERVISOR, icon: ManageAccountsSharpIcon, canEdit: false },
  { label: ADD_AGENT_NODE, type: AGENT, icon: AgentIcon, canEdit: false },
  { label: ADD_TOOL_NODE, type: TOOL, icon: ConstructionIcon, canEdit: false },
  { label: ADD_END_NODE, type: END, icon: StopCircleSharpIcon, canEdit: false }
  // Group or sub-flow changes are now hold until next notice, commenting the sidepanel icon
  // { label: GROUP_UNGROUP, type: GROUP, icon: DynamicFeedIcon }
];
